import {Component, computed, input, InputSignal} from '@angular/core';

import {FormatByMeasurePipe} from '@selpia/measures/pipes';
import {TileTable} from '@selpia/app-config/data-access';

import {SelectValuePipe} from '../pipes';
import {DataPoint} from '@selpia/shared/models';

export interface TableLayout {
  tileTable: TileTable;
  periodCode: string;
  date: Date | undefined;
}

@Component({
  selector: 'lib-data-table',
  imports: [
    SelectValuePipe,
    FormatByMeasurePipe,
  ],
  templateUrl: './data-table.component.html',
  styleUrl: './data-table.component.scss',
  host: {
    '[style.--data-columns]': 'this.columns() - 1',
  },
})
export class DataTableComponent {
  readonly dataPoints: InputSignal<DataPoint[]> = input.required();
  readonly layout: InputSignal<TableLayout> = input.required();

  protected readonly columns = computed(() => this.layout().tileTable.columns.length || 1)
}
